module.exports = __webpack_public_path__ + "img/calendar-icon.63e11978.svg";